import { call } from 'redux-saga/effects';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';

export default function* centrifugeDisconnection(action) {
  try {
    if (window.centrifugeConnection) {
      window.centrifugeConnection.disconnect();
      window.centrifugeConnection = null;
    }
  } catch (e) {
    yield call(rejectActionPromise(action, e));
  }
}
